import { useState, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import PageSectionList from '../../../../shared/components/layouts/PageSectionList'
import FormDrawer from '../../../../shared/components/drawers/FormDrawer'
import CronJobForm from './CronJobForm'
import { useConfirmationDialog } from '../../../../system/ConfirmationDialogProvider'

function ServiceCronJobsTab({
  cronJobs,
  cronJobsLoading,
  createCronJob,
  updateCronJob,
  destroyCronJob,
}) {
  const { openConfirmationDialog } = useConfirmationDialog()
  const [drawer, setDrawer] = useState({ open: false, cronJob: null })

  const handleOpenDrawer = useCallback((cronJob = null) => {
    setDrawer({ open: true, cronJob })
  }, [])

  const handleCloseDrawer = useCallback(() => {
    setDrawer({ open: false, cronJob: null })
  }, [])

  const handleDelete = useCallback((cronJob) => {
    openConfirmationDialog({
      title: <FormattedMessage id="cronJobs.delete.title" />,
      message: <FormattedMessage id="cronJobs.delete.message" />,
      onConfirm: () => destroyCronJob(cronJob.id),
      onCancel: () => Promise.resolve(),
    })
  }, [openConfirmationDialog, destroyCronJob])

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleOpenDrawer()}
        >
          <FormattedMessage id="dockerServices.show.addCronJob" />
        </Button>
      </Box>

      {cronJobsLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <PageSectionList
          items={cronJobs}
          emptyId="dockerServices.show.cronJobsEmpty"
          renderItem={(cronJob) => ({
            primary: cronJob.cronExpression,
            secondary: cronJob.command,
          })}
          onItemClick={handleOpenDrawer}
          onItemDelete={handleDelete}
        />
      )}

      <FormDrawer
        open={drawer.open}
        onClose={handleCloseDrawer}
        titleId={drawer.cronJob ? 'cronJobs.edit.title' : 'cronJobs.create.title'}
      >
        <CronJobForm
          cronJob={drawer.cronJob}
          createCronJob={createCronJob}
          updateCronJob={updateCronJob}
          onSuccess={handleCloseDrawer}
          onCancel={handleCloseDrawer}
        />
      </FormDrawer>
    </>
  )
}

export default ServiceCronJobsTab
